<template>
  <div class="c-item-specs">
    <dl
      class="c-item-specs__spec"
      v-for="(spec, specKey) in specs"
      :key="specKey"
    >
      <dt class="c-item-specs__spec__term">{{ spec.term }}：</dt>
      <dd class="c-item-specs__spec__description">{{ spec.description }}</dd>
    </dl>
    <dl class="c-item-specs__spec" v-if="qty">
      <dt class="c-item-specs__spec__term">個数: {{ qty }}</dt>
    </dl>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
	props: {
		specs: { type: Array, required: false },
		qty: { type: Array, required: false }
	}
})
export default class ItemSpecs extends Vue {
  specs!: any;
  qty!: any;
}
</script>

<style lang="scss" scoped>
.c-item-specs {
  &__spec {
    display: flex;

    margin-top: rem(2);

    &:first-child {
      margin-top: 0;
    }
  }

  &__spec__term {
    color: $common-black-sub;
    font-size: rem(14);
    line-height: (19/14);
  }
  &__spec__description {
    color: $common-black-sub;
    font-size: rem(14);
    line-height: (19/14);
  }
}
</style>
